module.exports = __webpack_public_path__ + "static/media/Apply-online.0659d4fe.jpeg";